<template>
    <v-container>
        <v-card-title>
            <CreateProduct :id="order.id" v-on:created="getProducts()"></CreateProduct>
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="products.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs">{{ props.item.code }}</td>
                <td class="text-xs">{{ props.item.product_description }}</td>
                <td class="text-xs">{{ props.item.units }}</td>
                <td class="text-xs">{{ props.item.price_kg }}</td>
                <td class="text-xs">{{ props.item.price }}</td>
                <td class="layout px-0 align-center">
                    <v-menu
                            transition="slide-y-transition"
                            bottom
                            left
                    >
                        <v-btn
                                slot="activator"
                                color="primary"
                                dark
                                fab
                                flat
                        >
                            <v-icon>settings</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile>
                                <EditProduct :id="order.id" :product_id="props.item.id" v-on:created="getProducts()"></EditProduct>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn flat block v-on:click="deleteItem(props.item.id)"><v-icon left>delete</v-icon>Delete</v-btn>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="products.data">
            <v-pagination
                    v-model="page"
                    :length="last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
                    @input="setPage"
            ></v-pagination>
            <p class="subtitle">Showing {{ products.meta.from }} to {{ products.meta.to }} of {{ products.meta.total }} entries</p>
        </div>

        <v-layout column>
            <v-flex>
                <ckeditor type="classic" v-model="order.text" :config="markdownConfig"></ckeditor>
            </v-flex>
            <v-flex>
                <v-btn color="secondary" class="text--primary" @click="saveText()">Save</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    import CreateProduct from './components/CreateProduct';
    import EditProduct from './components/EditProduct';
    import { DICCIONARIO } from '../../../../diccionario';
    import { VueEditor } from "vue2-editor";

    export default {
        props: ['order'],
        data: function () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {},
                loading: true,
                headers: [
                    {
                        text: 'Code',
                        align: 'left',
                        sortable: false,
                        value: 'code'
                    },
                    { text: 'Product', value: 'product', sortable: false },
                    { text: 'Units', value: 'units', sortable: false },
                    { text: 'Price(Kg)', value: 'pricekg', sortable: false },
                    { text: 'Price', value: 'price', sortable: false },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                products: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                markdownConfig: {
                    language: 'es',
                    enterMode: '<br/>'
                }
            }
        },
        created () {
            this.getProducts();
            this.debouncedGetProducts = _.debounce(this.getProducts, 500)
        },
        mounted () {
            this.$validator.localize('en', DICCIONARIO)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetProducts();
            },
            last_page: function () {
                if (this.page > this.products.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods: {
            deleteItem (id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteOrderLine', {
                            order_id: this.order.id,
                            order_line_id: id
                        }).then((res) => {
                            this.getProducts()
                        }).catch((error) => {

                        });
                    }
                })
            },
            setPage (page) {
                this.page = page;
                this.getOrders();
            },
            getProducts () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        id: this.order.id
                    }
                };
                this.$store.dispatch('getProducts', params).then((res) => {

                    this.products = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
            saveText () {
                this.$store.dispatch('saveAdditionalText', {
                    id: this.order.id,
                    text: this.order.text
                }).then((res) => {

                    this.$store.dispatch('setSnackBarText', {
                        text: 'Order confirmation commented successfully.'
                    });
                    this.$store.dispatch('activeSnack')
                    this.$emit('update');

                }).catch((error) => {

                });
            }
        },
        components: {
            CreateProduct,
            EditProduct,
            VueEditor
        }
    }
</script>

<style>
    .ck-content{
        height: 200px;
    }
</style>


// WEBPACK FOOTER //
// src/components/admin/orders/views/InfoComponent.vue